import { render, staticRenderFns } from "./EmptyAccountPlace.vue?vue&type=template&id=ded37314&scoped=true&"
import script from "./EmptyAccountPlace.vue?vue&type=script&lang=ts&"
export * from "./EmptyAccountPlace.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyAccountPlace.vue?vue&type=style&index=0&id=ded37314&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded37314",
  null
  
)

export default component.exports